
import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect }  from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import { languageManager } from '../utils/languageManager'

import Button from '@material-ui/core/Button';
import ListItem from '@material-ui/core/ListItem';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import SettingsSharpIcon from '@material-ui/icons/SettingsSharp';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import CloudIcon from '@material-ui/icons/Cloud';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import Tooltip from '@material-ui/core/Tooltip';

import Checkbox from '@material-ui/core/Checkbox';


import { COLOR } from '../App/constants';



const styles = theme => ({  

    item: {
      display: "flex",
      alignItems: "center",
      cursor: 'pointer',      
      padding: "5px 0px",
    },

    listSlides: {
      borderTop: '1px solid #DDD',
      //borderBottom: '1px solid #DDD',
      marginBottom: -1,     
      display: 'flex',
      alignItems: 'start', 
    },
    itemName: {      
      color: '#777',
      marginTop: 4,
      userSelect: 'none',
      cursor: 'pointer',
    },
    iconHelp: {
      color: '#777',
      margin: '1px 5px',
    },
    customTooltipWidth: {
      maxWidth: 500,
      margin: 2,
    },
});

class FwSlideListSelectionItem extends React.Component {
  
  render() {
    const { classes,slideName,openedObj,id,idSelected } = this.props;
       

    console.log('Pinta items',this.props);
    //Si no es un item con información de diapositivas sino un item de ayuda
    //esto pasa cuando el usuario no tiene diapositivas entonces se le muestra un
    //item que dice que debe abrir powerpoint
    if(this.props.helpItem) {      
      return (
        <ListItem className={classes.listSlides}>        
          <HelpOutlineIcon className={classes.iconHelp}/>
          <Tooltip title={
            languageManager.getLangWord('TOOLTIP_HELPITEM')
          } classes={{ tooltip: classes.customTooltipWidth }} enterTouchDelay={200}>
            
            <div className={classes.itemName}>{slideName}</div>
           </Tooltip>  
        </ListItem>      
      );
    }

    var slideIcon = this.props.isCloud?<CloudIcon className={classes.iconHelp}/>:<DesktopWindowsIcon className={classes.iconHelp}/>
    
    var classesEditButton = this.props.isCloud?[classes.iconAction,classes.iconDisabled].join(' '):classes.iconAction;

    return (
      <React.Fragment>
        <div className={classes.item} style={{backgroundColor:this.props.id%2==0?'white':'#d3d3d363'}} onClick={() => this.props.onSlideItemSelected(id,slideName)} >
          <Checkbox
              checked={id===idSelected}              
          />
          <div className={classes.slideName}>{slideName}</div>
        </div>        
      </React.Fragment>
    );
  }
}  
  
FwSlideListSelectionItem.propTypes = {
  dispatch: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

FwSlideListSelectionItem.contextTypes = {
  store: PropTypes.object,
};

export default connect()(withStyles(styles,{ withTheme: true })(FwSlideListSelectionItem));



// WEBPACK FOOTER //
// ./src/containers/components/FwSlideListSelectionItem.js